import React from 'react'
import SanityLink from '@/lib/SanityLink'
import clsx from 'clsx'

const UtilityNav = ({ nav }) => {
	return (
		<nav className="max-w-screen-xl mx-auto flex justify-end font-serif">
			{nav?.map((link, key) => (
				<SanityLink
					className={clsx(
						'p-2 transition-colors',
						link?.label === 'Donate'
							? 'bg-orange hover:bg-orange-light text-white px-4'
							: 'hover:text-orange'
					)}
					{...link}
					key={key}
				/>
			))}
		</nav>
	)
}

export default UtilityNav
